// eslint-disable-next-line @typescript-eslint/no-unused-vars
import UIkit from 'uikit/dist/js/uikit-core';
// import initAnchorData from './theme/anchorData';
import initanchorDataUiKit from './theme/anchorDataUiKit';
import initBackgroundColorChange from './theme/backgroundColorChange';
import initBiolist from './theme/bioList';
import initConditionPicker from './theme/conditionPicker';
import initHeaderMenu from './theme/headerMenu';
import initLocationDetailMap from './theme/locationDetailMap';
import initLocationSearchMap from './theme/locationSearchMap';
import initPlayVideo from './theme/playVideo';
import initSlideshows from './theme/slideshow';
import initSliderButtons from './theme/sliderButtons';
import initFields from './theme/fields';
import initProgramsAndServicesPage from './theme/programsAndServicesPage';
import initSearchPage from './theme/searchPage';
import initResourceLibrary from './theme/resourceLibrary';
import initNewsArticles from './theme/newsArticles';
import initActiveTreatmentLocator from './theme/activeTreatmentLocator';
import { initVisitLog } from './theme/visitLog';
import initSalesForceForms from './theme/salesForceForm';
import initGoBackButton from './theme/goBackButton';
import initUrlParameter from './theme/urlParameter';
import initMediaHero from './theme/mediaHero';

// initAnchorData();
initFields();
initActiveTreatmentLocator();
initanchorDataUiKit();
initBackgroundColorChange();
initBiolist();
initConditionPicker();
initHeaderMenu();
initLocationDetailMap();
initLocationSearchMap();
initPlayVideo();
initSlideshows();
initSliderButtons();
initProgramsAndServicesPage();
initSalesForceForms();
initSearchPage();
initResourceLibrary();
initNewsArticles();
initVisitLog();
initGoBackButton();
initUrlParameter();
initMediaHero();
